import { Box, Typography, IconButton, Divider, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { 
  Telegram, 
  GitHub, 
  Twitter, 
  Mail, 
  Phone,
  LocationOn
} from '@mui/icons-material';

export const Footer = () => {
  const navigate = useNavigate();
  
  return (
    <Box
      component="footer"
      sx={{
        background: 'linear-gradient(135deg, #0a0a0a 0%, #1a1a2e 100%)',
        borderTop: '1px solid rgba(147, 51, 234, 0.3)',
        backdropFilter: 'blur(20px)',
        mt: 'auto',
        py: 4,
        position: 'relative',
        zIndex: 100,
        pointerEvents: 'auto',
      }}
    >
      <Container maxWidth="lg">
        {/* Основной контент футера */}
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: 4, mb: 4 }}>
          {/* Логотип и описание */}
          <Box sx={{ flex: 1, minWidth: { xs: '100%', md: '300px' } }}>
            <Typography 
              variant="h5" 
              component="div"
              sx={{ 
                fontWeight: 700,
                background: 'linear-gradient(45deg, #9c27b0 30%, #e91e63 90%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                textShadow: '0 0 30px rgba(233, 30, 99, 0.5)',
                mb: 2,
                fontSize: '1.5rem'
              }}
            >
              Name Store
            </Typography>
            <Typography 
              variant="body2" 
              sx={{ 
                color: '#b388ff',
                opacity: 0.8,
                lineHeight: 1.6,
                mb: 2
              }}
            >
              Премиальный интернет-магазин в стиле киберпанк. 
              Лучшие товары для современного мира.
            </Typography>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <IconButton 
                size="small"
                sx={{ 
                  color: '#e91e63',
                  '&:hover': {
                    background: 'rgba(233, 30, 99, 0.2)',
                    boxShadow: '0 0 15px rgba(233, 30, 99, 0.4)',
                  }
                }}
              >
                <Telegram fontSize="small" />
              </IconButton>
              <IconButton 
                size="small"
                sx={{ 
                  color: '#e91e63',
                  '&:hover': {
                    background: 'rgba(233, 30, 99, 0.2)',
                    boxShadow: '0 0 15px rgba(233, 30, 99, 0.4)',
                  }
                }}
              >
                <Twitter fontSize="small" />
              </IconButton>
              <IconButton 
                size="small"
                sx={{ 
                  color: '#e91e63',
                  '&:hover': {
                    background: 'rgba(233, 30, 99, 0.2)',
                    boxShadow: '0 0 15px rgba(233, 30, 99, 0.4)',
                  }
                }}
              >
                <GitHub fontSize="small" />
              </IconButton>
            </Box>
          </Box>

          {/* Навигация */}
          <Box sx={{ flex: 1, minWidth: { xs: '100%', md: '200px' } }}>
            <Typography 
              variant="h6" 
              sx={{ 
                color: '#ffffff',
                fontWeight: 600,
                mb: 2,
                fontSize: '1.1rem'
              }}
            >
              Навигация
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              {[
                { name: 'Главная', path: '/' },
                { name: 'Каталог', path: '/catalog' }
              ].map((item) => (
                <Typography 
                  key={item.name}
                  variant="body2"
                  onClick={() => {
                    console.log('Footer navigation clicked:', item.path);
                    navigate(item.path);
                  }}
                  sx={{
                    color: '#b388ff',
                    opacity: 0.8,
                    transition: 'all 0.3s ease',
                    cursor: 'pointer',
                    textDecoration: 'none',
                    pointerEvents: 'auto',
                    position: 'relative',
                    zIndex: 10,
                    '&:hover': {
                      color: '#e91e63',
                      opacity: 1,
                      textShadow: '0 0 10px rgba(233, 30, 99, 0.4)',
                      textDecoration: 'none',
                    }
                  }}
                >
                  {item.name}
                </Typography>
              ))}
            </Box>
          </Box>

          {/* Контакты */}
          <Box sx={{ flex: 1, minWidth: { xs: '100%', md: '250px' } }}>
            <Typography 
              variant="h6" 
              sx={{ 
                color: '#ffffff',
                fontWeight: 600,
                mb: 2,
                fontSize: '1.1rem'
              }}
            >
              Контакты
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Mail sx={{ fontSize: 16, color: '#e91e63' }} />
                <Typography 
                  variant="body2" 
                  sx={{ 
                    color: '#b388ff',
                    opacity: 0.8
                  }}
                >
                  info@namestore.com
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Phone sx={{ fontSize: 16, color: '#e91e63' }} />
                <Typography 
                  variant="body2" 
                  sx={{ 
                    color: '#b388ff',
                    opacity: 0.8
                  }}
                >
                  +7 (999) 123-45-67
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <LocationOn sx={{ fontSize: 16, color: '#e91e63' }} />
                <Typography 
                  variant="body2" 
                  sx={{ 
                    color: '#b388ff',
                    opacity: 0.8
                  }}
                >
                  Киберпанк-сити, 2077
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>

        {/* Разделитель */}
        <Divider sx={{ 
          background: 'rgba(147, 51, 234, 0.3)', 
          mb: 3 
        }} />

        {/* Копирайт */}
        <Box sx={{ 
          display: 'flex', 
          justifyContent: { xs: 'center', md: 'space-between' },
          alignItems: 'center',
          flexDirection: { xs: 'column', md: 'row' },
          gap: 2
        }}>
          <Typography 
            variant="body2" 
            sx={{ 
              color: '#b388ff',
              opacity: 0.6,
              textAlign: { xs: 'center', md: 'left' }
            }}
          >
            © 2077 Name Store. Все права защищены.
          </Typography>
          <Typography 
            variant="body2" 
            sx={{ 
              color: '#b388ff',
              opacity: 0.6,
              textAlign: { xs: 'center', md: 'right' }
            }}
          >
            Создано с ❤️ в стиле киберпанк
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};
